import React, { ChangeEvent, FC, useMemo, useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { ReactTable, AddButton, TextInput } from '@td-client-frontend/common';
import { emptyGroup } from '../../../utils/groups/incomingDataTransformation';
import { useGroupContext } from '../../../context/GroupContext';
import { GroupPackage } from '../../../@types/Groups';

const BenefitGroupTable: FC<{ onManage: (index: number) => void }> = ({ onManage }) => {
  const [filter, setFilterValue] = useState<string>('');
  const { getValues } = useFormContext();
  const { setBenefitIdx } = useGroupContext();

  const { append } = useFieldArray({ name: 'groups' });

  const preparedGroups: GroupPackage[] = useMemo(() => {
    return (
      getValues('groups')?.reduce((acc: GroupPackage[], group: GroupPackage) => {
        if (!filter || group.name.toLowerCase().includes(filter.toLowerCase())) {
          return [
            ...acc,
            {
              ...group,
              name: group?.name || '---',
              planNumbers: group.planCodes?.map((planCode) => planCode.code).join(', ') || '---'
            }
          ];
        }
        return acc;
      }, []) || []
    );
  }, [filter, getValues]);

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => setFilterValue(event.target.value);

  const handleAddGroup = () => {
    append(emptyGroup);
    setBenefitIdx(preparedGroups.length || 0);
  };

  const tableConfig = useMemo(
    () => [
      {
        Header: 'Plan Name',
        accessor: 'name'
      },
      {
        Header: 'Status',
        accessor: 'status',
        disableSortBy: true
      },
      {
        Header: 'Actions',
        disableSortBy: true,
        Cell: ({ row: { index } }) => {
          return (
            <button
              type="button"
              className="flex text-primary-500 hover:text-primary-70"
              onClick={() => onManage(index)}
            >
              Manage
            </button>
          );
        }
      }
    ],
    [onManage]
  );

  return (
    <>
      <div className="flex justify-between py-4">
        <AddButton label="New plan" onClick={handleAddGroup} />
        <TextInput onChange={handleSearch} placeholder="Find or type plan name" />
      </div>
      <ReactTable columns={tableConfig} data={preparedGroups} showEmptyMsg={false} />
    </>
  );
};

export default BenefitGroupTable;
